var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dl-btn"},[_c('button',{staticClass:"button vivify pulsate infinite",attrs:{"id":"dl-btn","data-clipboard-text":_vm.clipboardText},on:{"click":function($event){return _vm.copyDownload('#dl-btn', '点击下载')}}},[_c('i',{staticClass:"coin"}),_vm._v(" 点击下载快音，让音乐更懂你 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }